module.exports = __webpack_public_path__ + "33c6c5306d995e7dd4be4e4f81e87189.svg";